
// Minimal markdown → React for the legal pages: headings, paragraphs, bullet lists, pipe tables, **bold**, [links](url).
const INLINE = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;

function renderInline(text) {
  return text.split(INLINE).filter(Boolean).map((part, i) => {
    if (part.startsWith("**")) return <strong key={i}>{part.slice(2, -2)}</strong>;
    const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (link) return <a key={i} href={link[2]}>{link[1]}</a>;
    return part;
  });
}

function splitRow(line) {
  return line.trim().replace(/^\|/, "").replace(/\|$/, "").split("|").map((c) => c.trim());
}

export default function renderMarkdown(md) {
  const lines = md.split("\n");
  const out = [];
  let para = [];
  let list = [];
  let table = [];

  const flushPara = () => {
    if (para.length) out.push(<p key={out.length}>{renderInline(para.join(" "))}</p>);
    para = [];
  };
  const flushList = () => {
    if (list.length) out.push(<ul key={out.length}>{list.map((item, i) => <li key={i}>{renderInline(item)}</li>)}</ul>);
    list = [];
  };
  const flushTable = () => {
    if (!table.length) return;
    const [head, ...body] = table;
    out.push(
      <table key={out.length}>
        <thead><tr>{head.map((c, i) => <th key={i}>{renderInline(c)}</th>)}</tr></thead>
        <tbody>{body.map((row, r) => <tr key={r}>{row.map((c, i) => <td key={i}>{renderInline(c)}</td>)}</tr>)}</tbody>
      </table>
    );
    table = [];
  };
  const flushAll = () => { flushPara(); flushList(); flushTable(); };

  for (const raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) { flushAll(); continue; }
    if (line.startsWith("# ")) { flushAll(); out.push(<h1 key={out.length}>{line.slice(2)}</h1>); continue; }
    if (line.startsWith("## ")) { flushAll(); out.push(<h2 key={out.length}>{line.slice(3)}</h2>); continue; }
    if (line.startsWith("- ")) { flushPara(); flushTable(); list.push(line.slice(2)); continue; }
    if (line.startsWith("|")) {
      flushPara(); flushList();
      if (!/^\|\s*-+/.test(line)) table.push(splitRow(line));
      continue;
    }
    flushList(); flushTable();
    para.push(line.trim());
  }
  flushAll();
  return out;
}
